<!-- home -->
<template>
  <Layout>
    <p class="competion-empty" v-if="competionEmpty"  :style="setStyle('main','color')">暂无可参加的诊断，请联系老师</p>
    <div class="home">
      <div v-for="(item, i) in moduleData" :key="i" class="modules_item">
        <tem-all v-show="!(+compType===3 && item.moduleType===6)" :temData="item" />
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/components/Layout'
import temAll from '@/views/home/temAll'
import { getCompModuleList } from "@/services/home";
import { mapGetters,mapState } from 'vuex'
import { setColor } from '../../utils/style'

export default {
  data () {
    return {
      moduleData: ''
    };
  },

  components: {
    temAll,
    Layout
  },

  computed: {
    ...mapState({
      compType: state => state.router.compType,
      'refreshState':state=>state.user.refreshState,
      globalConfig: state => state.router.globalConfig,
    }),
    bannerUrl() {
      return ''
    },
    ...mapGetters([
        'loginStatus',
    ]),
    competionEmpty() {
      return this.loginStatus && this.compType === 3 && !(this.moduleData && this.moduleData.find(item=>item.moduleType === 5))
    }
  },
  watch: {
    $route() {
      this.getModuleList()
    },
    loginStatus(){
      this.getModuleList()
    },
    '$store.state.user.isInsidSignUp'(newVal){
      if(newVal) return this.getModuleList()
    },
    refreshState(newVal){
      newVal.flag && this.getModuleList()
    }
  },
  mounted() {
    this.getModuleList()
  },

  methods: {
    async getModuleList() {
      
      const { id } = this.$route.meta
      try {
        
        const res = await getCompModuleList({id})
        this.moduleData = res.data || []
        const applyInfo = this.moduleData.filter(item => item.moduleType === 6)[0]
        
        this.refreshState.flag && this.refreshState.type === 'btn' && this.$message.showMessage({info: '刷新成功'})
        this.$store.dispatch(
          'saveRegInfo',
          applyInfo.moduleRegister,
        )
        this.$store.commit('SAVE_BGURL',applyInfo.bgDataUrl)
        
      } catch (error) {
        // this.$message.showMessage({info: `${error.statusText}`})
      }
    },
    setStyle(key, type) {
      return setColor(this.globalConfig, key, type);
    },
  },
}

</script>
<style lang='less' scoped>
@import "~@/assets/less/mixin.less";
@IMG_URL: '../../assets';
.competion-empty {
  text-align: center;
  font-size: 20px;
  margin: 64px 0 0;
  line-height: 50px;
}
.home {
  width: 100%;
  .banner {
    width: 100%;
    height: 533px;
  }
  .modules_item{
    padding-top:64px;
  }
}
</style>